var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashupBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25.9999999px",
    viewBox: "0 0 26 25.9999999",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:currency-pound") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Light-New-Icons",
    transform: "translate(-16, -235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:currency-pound",
    transform: "translate(13, 232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.828,10.172 C17.7388433,9.08300135 16.1211878,8.71607403 14.6687683,9.22857553 C13.2163487,9.74107703 12.1871969,11.0419581 12.0226667,12.5733333 C11.9997792,12.8564523 12.0123206,13.1413211 12.06,13.4213333 L12.7346667,18.1426667 C12.9075167,19.3513454 12.7075023,20.5839922 12.1613333,21.676 L12,22 L14.052,21.316 C14.6673821,21.1110368 15.3326179,21.1110368 15.948,21.316 L16.8213333,21.6066667 C17.5762428,21.8583997 18.4002393,21.7998854 19.112,21.444 L20,21 M11,16 L16,16 M28,16.0000003 C28,20.2871871 25.712813,24.2487114 22,26.392305 C18.2871871,28.5358986 13.7128129,28.5358986 10,26.392305 C6.287187,24.2487114 4,20.2871871 4,16.0000003 C4,9.3725831 9.3725831,4.00000025 16,4.00000025 C22.6274169,4.00000025 28,9.3725831 28,16.0000003 L28,16.0000003 Z",
    id: "Shape",
    stroke: "#192340",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashupBlack);
export default __webpack_public_path__ + "static/media/cashup-black.be2f7d607d6745b85ef951e389445f97.svg";
export { ForwardRef as ReactComponent };